/**
 * "Cancelled" - axios canceler cancelation message
 * "canceled" - axios abortController cancelation message
 *
 * @param {any} error
 * @param {AbortController} abortController
 * @returns {boolean}
 */
export const isCanceledRequest = (error: any, abortController?: AbortController): boolean => {
  if (abortController) return abortController.signal.aborted;
  return error?.message && ['Cancelled', 'canceled'].includes(error.message);
};
